var _line, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeline04Icuida(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "timeline_04_icuida",
    xmlns: "http://www.w3.org/2000/svg",
    width: 330.5,
    height: 583.159,
    viewBox: "0 0 330.5 583.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_40",
    "data-name": "L\\xEDnea 40",
    x1: 105.5,
    transform: "translate(225 112.802)",
    fill: "none",
    stroke: "#ce6854",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1219",
    "data-name": "Grupo 1219",
    transform: "translate(-510.533 -357.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_866",
    "data-name": "Trazado 866",
    d: "M0,0V390.357",
    transform: "translate(650 550)",
    fill: "none",
    stroke: "#ce6854",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1216",
    "data-name": "Grupo 1216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1214",
    "data-name": "Grupo 1214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1212",
    "data-name": "Grupo 1212"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_193",
    "data-name": "Elipse 193",
    cx: 97.344,
    cy: 97.344,
    r: 97.344,
    transform: "translate(541.176 552.273) rotate(-80.679)",
    fill: "#8ccee1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_194",
    "data-name": "Elipse 194",
    cx: 81.163,
    cy: 81.163,
    r: 81.163,
    transform: "translate(538.219 471.98) rotate(-45)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_04.",
    "data-name": 4,
    transform: "translate(572.683 410.105)",
    fill: "#00334e",
    fontSize: 36.479,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "04."))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1213",
    "data-name": "Grupo 1213"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_79",
    "data-name": "Rect\\xE1ngulo 79",
    width: 284.937,
    height: 41.829,
    transform: "translate(510.533 587.392)",
    fill: "#ce6854"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Febrero_2019",
    "data-name": "Febrero 2019",
    transform: "translate(580.397 617.882)",
    fill: "#fff",
    fontSize: 16.576,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Febrero 2019")))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1215",
    "data-name": "Grupo 1215"
  }, /*#__PURE__*/React.createElement("text", {
    id: "II_Hackathon_",
    "data-name": "II Hackathon ",
    transform: "translate(570.156 453.556)",
    fontSize: 25.097,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.149,
    y: 23
  }, "II Hackathon")))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1218",
    "data-name": "Grupo 1218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1217",
    "data-name": "Grupo 1217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_858",
    "data-name": "Trazado 858",
    d: "M706.917,377.314l-9.557,4.779-2.137-4.274,9.557-4.779Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_859",
    "data-name": "Trazado 859",
    d: "M704.779,415.547l-9.557-4.779,2.137-4.274,9.557,4.779Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_860",
    "data-name": "Trazado 860",
    d: "M698.678,391.9H708.4v4.779h-9.717Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_861",
    "data-name": "Trazado 861",
    d: "M630.456,373.041l9.557,4.778-2.138,4.274-9.556-4.778Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_862",
    "data-name": "Trazado 862",
    d: "M630.454,415.545l-2.136-4.274,9.556-4.779,2.138,4.274Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_863",
    "data-name": "Trazado 863",
    d: "M626.839,391.9h9.716v4.779h-9.716Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_864",
    "data-name": "Trazado 864",
    d: "M660.449,444.788h14.336v4.779H660.449Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_865",
    "data-name": "Trazado 865",
    d: "M693.9,394.293a26.283,26.283,0,1,0-38.23,23.377v7.684h-4.779v4.779h4.779v9.876h23.894v-9.876h4.778v-4.779h-4.778V417.67A26.293,26.293,0,0,0,693.9,394.293ZM674.785,435.23H660.449v-5.1h14.336Zm-9.557-36.158a2.389,2.389,0,1,1,2.389,2.389A2.392,2.392,0,0,1,665.228,399.072Zm4.778,26.282V405.829a7.168,7.168,0,1,0-4.778,0v19.525h-4.779V414.6l-1.429-.627a21.5,21.5,0,1,1,17.194,0l-1.429.627v10.754Z",
    fill: "#1f2121"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline04Icuida);
export default __webpack_public_path__ + "static/media/timeline_04_icuida.927ccc8f1f5d7e59b13dc2b55835b948.svg";
export { ForwardRef as ReactComponent };